import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.515 17.543a.87.87 0 0 0 .635.265q.372 0 .636-.265a.87.87 0 0 0 .264-.635.87.87 0 0 0-.264-.636.87.87 0 0 0-.636-.264.87.87 0 0 0-.636.264.87.87 0 0 0-.264.636q0 .372.264.635M11.57 14.625q.24.24.58.24a.8.8 0 0 0 .578-.24q.241-.24.241-.579l.2-5.227a.8.8 0 0 0-.24-.578c-.16-.16-.552-.241-.778-.241s-.619.08-.78.24a.79.79 0 0 0-.24.58l.2 5.226q0 .338.24.579"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.413 16.59c-1.095 1.833.226 4.16 2.361 4.16h14.452c2.135 0 3.456-2.327 2.361-4.16l-7.226-12.1c-1.067-1.786-3.655-1.786-4.722 0zm2.361 2.66a1.25 1.25 0 0 1-1.073-1.89l7.226-12.1a1.25 1.25 0 0 1 2.146 0l7.226 12.1a1.25 1.25 0 0 1-1.073 1.89z",
    clipRule: "evenodd"
  }));
}
var IcError = createNolIcon(/*#__PURE__*/forwardRef(SvgIcError));

export { IcError as I };
